/* eslint-disable */
import { phoneTypes } from '@ringcentral-integration/commons/enums/phoneTypes';
export default {
  [phoneTypes.business]: 'Telefono azienda',
  [phoneTypes.extension]: 'Interno',
  [phoneTypes.home]: 'Numero casa',
  [phoneTypes.mobile]: 'Telefono cellulare',
  [phoneTypes.phone]: 'Telefono',
  [phoneTypes.unknown]: 'Tipo di telefono sconosciuto',
  [phoneTypes.company]: 'Numero aziendale',
  [phoneTypes.direct]: 'Numero diretto',
  [phoneTypes.contact]: 'Telefono di contatto',
  [phoneTypes.fax]: 'Fax',
  [phoneTypes.other]: 'Altro',
};

// @key: @#@"[phoneTypes.business]"@#@ @source: @#@"Business Phone"@#@
// @key: @#@"[phoneTypes.extension]"@#@ @source: @#@"Extension Number"@#@
// @key: @#@"[phoneTypes.home]"@#@ @source: @#@"Home Number"@#@
// @key: @#@"[phoneTypes.mobile]"@#@ @source: @#@"Mobile Phone"@#@
// @key: @#@"[phoneTypes.phone]"@#@ @source: @#@"Phone"@#@
// @key: @#@"[phoneTypes.unknown]"@#@ @source: @#@"Unknown Phone Type"@#@
// @key: @#@"[phoneTypes.company]"@#@ @source: @#@"Company Number"@#@
// @key: @#@"[phoneTypes.direct]"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"[phoneTypes.contact]"@#@ @source: @#@"Contact Phone"@#@
// @key: @#@"[phoneTypes.fax]"@#@ @source: @#@"Fax"@#@
// @key: @#@"[phoneTypes.other]"@#@ @source: @#@"Other"@#@
